import _extends from "@babel/runtime/helpers/esm/extends";
// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY

import * as React from 'react';
import TeamOutlinedSvg from "@ant-design/icons-svg/es/asn/TeamOutlined";
import AntdIcon from "../components/AntdIcon";
var TeamOutlined = function TeamOutlined(props, ref) {
  return /*#__PURE__*/React.createElement(AntdIcon, _extends({}, props, {
    ref: ref,
    icon: TeamOutlinedSvg
  }));
};
if (process.env.NODE_ENV !== 'production') {
  TeamOutlined.displayName = 'TeamOutlined';
}
export default /*#__PURE__*/React.forwardRef(TeamOutlined);